import { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import pure from 'recompose/pure';
import { FieldProps, Customer } from '../../../interface/types';
import AvatarField from '../../../component/AvatarField';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    whiteSpace: 'nowrap',
  },
  avatar: {
    marginRight: theme.spacing(1),
  },
}));

interface Props extends FieldProps<Customer> {
  size?: string;
}

const FullNameField: FC<Props> = ({ record, size }) => {
  const classes = useStyles();
  return record ? (
    <div className={classes.root}>
      <AvatarField className={classes.avatar} record={record} size={size} />
      {record.name}
    </div>
  ) : null;
};

const PureFullNameField = pure(FullNameField);

PureFullNameField.defaultProps = {
  source: 'name',
  label: 'resources.customers.fields.name',
};

export default PureFullNameField;
